<!-- Modal -->
<div class="modal fade" [id]="id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" id="modalLabel">{{header}}</div>
        <button type="button" class="close" aria-label="Close" (click)="proceedCancel()">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body" [innerHTML]="message">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="proceedYes()">{{okcaption}}</button>
        <button type="button" class="btn btn-link" *ngIf="isCancelShown" (click)="proceedCancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
